import { useMutation } from "@apollo/client";
import {
    constantsData,
    identifiersData,
    namesData,
    statusTypesData,
} from "data";
import { getDistributionsListQuery, retryFailedDistributionMutation } from "graph";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { openAlert } from "redux/actions";
import { displayErrorHandler } from "utils";

const useRetryFailedDistribution = (
    releaseId,
    limit,
    page,
) => {
    const { t } = useTranslation();

    const dispatch = useDispatch();

    const [retryFailedDistributionAction, { loading }] = useMutation(
        retryFailedDistributionMutation,
        {
            awaitRefetchQueries: true,
            refetchQueries: [
                {
                    query: getDistributionsListQuery,
                    variables: {
                        limit,
                        page,
                        ...releaseId && { releaseId },
                    },
                },
            ],
        },
    );

    const { retryFailedDistributionPending: retryFailedDistributionPendingToastName } = namesData.toasts;

    const { toast: toastId } = identifiersData.ids;

    const retryFailedDistribution = async (id) => {
        try {
            await retryFailedDistributionAction({
                onCompleted: () => {
                    dispatch(openAlert(
                        t("messages.distributionMsgs.retry.success"),
                        statusTypesData.success,
                    ));
                },
                variables: { id },
            });
        } catch (err) {
            displayErrorHandler(
                err.message === constantsData.failedToFetch ? t("messages.networkFailure") : err.message,
                dispatch,
                openAlert,
            );
        } finally {
            toast.dismiss(`${retryFailedDistributionPendingToastName}_${toastId}`);
        }
    };

    useEffect(
        () => {
            if (loading) {
                toast.info(
                    () => t(
                        "messages.distributionMsgs.retry.pending",
                    ),
                    { toastId: `${retryFailedDistributionPendingToastName}_${toastId}` },
                );
            }
        },
        [loading], //eslint-disable-line
    );

    return { retryFailedDistribution };
};

export default useRetryFailedDistribution;
